import { TeamModel } from '../../team/models/team.model';
import { ActivationCodeModel } from './activation-code.model';
import { UserFormModel } from './user-form.model';

export class ActivationModel {

  /**
   * Constructor
   *
   * @param activationCode
   * @param userForm
   * @param team
   */
  public constructor(
    public activationCode: ActivationCodeModel = new ActivationCodeModel(),
    public userForm: UserFormModel = new UserFormModel(),
    public team: TeamModel = new TeamModel(),
  ) {  }
}
